import YouTube from 'react-youtube'
import React, { Component } from 'react'
import css from '@emotion/css'

class Player extends Component {
    state = {
        player: null,
    }

    onReady = event => {
        this.props.handlePlayerInit(event.target)
    }

    onEnd = () => {}

    render() {
        return (
            <YouTube
                css={videoClass}
                className={this.props.isVideoPlaying ? 'is-visible' : ''}
                videoId={this.props.videoId}
                onEnd={this.props.onEnd}
                onReady={this.onReady}
                onPause={this.props.onEnd}
                opts={{
                    controls: 0,
                    fs: 0,
                    showinfo: 0,
                    rel: 0,
                    playsinline: 0,
                    modestbranding: 1,
                }}
            />
        )
    }
}

const videoClass = css`
    object-fit: cover;
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: opacity 0.5s linear;
    width: 100%;
    z-index: 3;

    &.is-visible {
        opacity: 1;
        transition: opacity 0.5s linear 0.5s;
    }
`

export default Player
